<ng-container *ngIf="isNative">
  <div class="create-frame" *ngIf="showWorld">
    <div class="">{{ 'choose_world' | translate}}</div>
    <div class="icons-container">
      <ng-container *ngFor="let world of worldsList">
        <div class="world-icon" matTooltip="{{world.world_name}}" *ngIf="world.be_app_name"
          (click)="chooseComponent($event, world)" (mouseenter)="setColor($event, world, true)"
          (mouseleave)="setColor($event, world, false)">
          <img src="{{world.image}}">
        </div>
      </ng-container>
    </div>
  </div>

  <div class="create-frame" *ngIf="!showWorld">
    <mat-form-field class="search-form-field" floatLabel="never">
      <mat-icon matPrefix style="color: #00B398;" svgIcon="search"></mat-icon>
      <input type="text" class="mdc-typography--body2" placeholder="Ricerca il componente" matInput
        [formControl]="searchComponentControl">
      </mat-form-field>
      
    <div
    style="max-height: 200px; overflow: auto; width: 76%; border: 1px solid #cfd0d1; border-radius: 4px; position: absolute; top: 101px;">
      <ng-container *ngFor="let key of keyList">
        <mat-accordion>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ key }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container *ngFor="let frame of filteredFramesOptions | async">
              <ng-container *ngIf="frame.key === key">
                <mat-list-item (click)="selectedFrame(frame)">
                  {{ frame.framenamedescr }}
                </mat-list-item>
              </ng-container>
            </ng-container>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-container>
    </div>

    <button class="back mdc-typography--button" (click)="showWorld=true">
      {{ 'back' | translate }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="isNative == false">
  <div class="create-frame">
    {{ 'not_configured_frame' | translate}}
  </div>
</ng-container>